import { BlocksGameLogic } from './blocks-game-logic';
import { BlocksDealer } from './dealer/blocks-dealer';

export class BlocksGameBuilder {
  public static newGame(dealer: BlocksDealer): BlocksGameLogic {
    const game = new BlocksGameLogic(dealer);
    return game;
  }
}
